import { Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useHistory } from "react-router";
import { SliderPage } from ".";
import {
  EXTERIOR_SAMPLES,
  PHOTOGRAPHY_SAMPLES,
  TWILIGHT_SAMPLES,
} from "../assets/images/samples";
import { InternalSection, VirtualStaging } from "../components";
import { BlockCheckbox, InlineCheckbox, Select } from "../components/fields";
import { Notes } from "../components/fields/Notes";
import AddonAlert from "../components/order/AddOnAlert";
import AddOnSection from "../components/order/AddOnSection";
import { useStockPhotos } from "../context/StockPhotosContext";
import { isInternal } from "../helpers";
import { useAddlPhotoValue } from "../hooks";
import useProductsSelected from "../hooks/useProductsSelected";

const photo_addon_skus = ["1301", "1317", "1318", "9814"];
const variant_addon_products = [
  { sku: "1317" },
  { sku: "1318" },
  { sku: "9814" },
];
const main_products = [
  {
    sku: "1010",
    modal: { urls: PHOTOGRAPHY_SAMPLES },
  },
  { sku: "1004", modal: { urls: TWILIGHT_SAMPLES } },
  { sku: "1006", modal: { urls: EXTERIOR_SAMPLES } },
  { sku: "1007", modal: { urls: EXTERIOR_SAMPLES } },
  { sku: "1011", modal: { urls: PHOTOGRAPHY_SAMPLES } },
];

const PhotosPage = () => {
  const history = useHistory();
  const { setValue, getValues, watch } = useFormContext();
  const { stock_regions, individual_price } = useStockPhotos();
  const addlPhotoValue = useAddlPhotoValue();
  const productsSelected = useProductsSelected(["1010"]);
  const stock_photos = watch("stock_photos");
  // useWhatChanged([vohProduct, vohRecommended, handleModal]);

  const addlPhotoVTOptions = () => {
    const options = [...Array(6)].map((_, value) => {
      value++;
      return addlPhotoValue(value);
    });
    return options;
  };

  const getRecommended = () => {
    const sqft = getValues("order_info.sq_ft");
    const recommended = Math.min(Math.ceil((sqft - 2500) / 500), 6);
    return { sqft, recommended };
  };

  const recommendPhotos = () => {
    const { sqft, recommended } = getRecommended();
    const text = (
      <p>
        For a property of {sqft} sqft{" "}
        <strong>
          we recommend at least {recommended * 5} additional photos
        </strong>{" "}
        to adequately capture all the rooms and features.
      </p>
    );
    const option = addlPhotoValue(recommended, "1301");
    const handleButton = () => {
      setValue("1301", option.value);
    };
    const button_text = `Add ${option.label}`;
    return { text, button_text, handleButton, display: recommended > 0 };
  };

  const recommendStock = (stock_regions) => {
    const text = (
      <p>
        Add great shots from the surrounding area from our extensive and
        affordable stock photo library.{" "}
        <strong>{`Only ${individual_price} each! Buy 4 and get the 5th free!`}</strong>
      </p>
    );
    const handleButton = () => {
      history.push("/stock-photos");
    };
    const button_text = stock_photos.length ? "Add More" : "Take A Look";
    return {
      text,
      button_text,
      handleButton,
      display: stock_regions,
      show_button: true,
    };
  };

  return (
    <SliderPage title="Photos">
      <Row>
        {main_products.map((product) => (
          <BlockCheckbox key={product.sku} {...product} />
        ))}
      </Row>
      {!productsSelected && !isInternal() && (
        <div className="mb-4">
          <h2 className="mb-4">Virtual Staging</h2>
          <div>
            If you would like virtual staging and already have photos from us or
            anywhere else, please contact our office at 250-388-6998 or
            orders@realfoto.ca
          </div>
        </div>
      )}
      {stock_regions && (
        <>
          <h2 className="mb-4">Stock Photography</h2>
          <AddonAlert {...recommendStock(stock_regions)} />
        </>
      )}
      <AddOnSection
        title="Photography Add-Ons"
        show_skus={["1010"]}
        addon_skus={photo_addon_skus}
      >
        <AddOnSection show_skus={["1010"]} addon_skus={["1301"]}>
          <AddonAlert {...recommendPhotos()}>
            <Select
              label="Additional Photos"
              sku="1301"
              options={addlPhotoVTOptions()}
              placeholder="Select additional photo quantity"
              isClearable
            />
          </AddonAlert>
        </AddOnSection>
        <VirtualStaging />
        {variant_addon_products.map((product) => (
          <InlineCheckbox key={product.sku} {...product} />
        ))}
      </AddOnSection>
      <InternalSection>
        <InlineCheckbox sku="1306" />
        <InlineCheckbox sku="1005" />
        <InlineCheckbox sku="1390" />
        <Notes name="notes.photo" label="Photo Appt Notes" />
      </InternalSection>
    </SliderPage>
  );
};

export default PhotosPage;
